import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationDialogComponent } from 'src/app/ChildControls/confirmation-dialog/confirmation-dialog.component';
import { Component_RoleMasterEnum, UserRoleservice } from 'src/app/Services/common.service';
import { configuration } from 'src/environments/environment';
import { CCDAService } from '../../ccda.service';

@Component({
  selector: 'app-data-export-recursive',
  templateUrl: './data-export-recursive.component.html',
  styleUrls: ['./data-export-recursive.component.css']
})
export class DataExportRecursiveComponent implements OnInit {
  public InputDetails: any;
  public PatientClinicalDataExportList: any = [];
  UserPermissions: string = '';
  constructor(
    private spinner: NgxSpinnerService,
    private _ccdaService: CCDAService,
    private _userRoleservice: UserRoleservice,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) templateData,
  ) {
    if (templateData != null && templateData.details != null) {
      this.InputDetails = templateData.details;
      this.UserPermissions = this._userRoleservice.getPermissionsByComponentId(Component_RoleMasterEnum.ClinicalDataExport);
    }
  }
  fnGetData() {
    this.spinner.show();
    this.PatientClinicalDataExportList = [];
    this._ccdaService.GetClinicalDataExport(this.InputDetails.ID).subscribe(result => {
      this.PatientClinicalDataExportList = result;
      this.spinner.hide();
    })
  }
  ngOnInit() {
    this.fnGetData();
  }
  openGenarateCCDA(FilePath) {
    //const url = configuration.clinicTokenUrl + '/Downloads/' + FilePath;//  window.URL.createObjectURL(blob);
    const url = configuration.ClinicalDataExport_DownloadURL + '/Downloads/' + FilePath;//  window.URL.createObjectURL(blob);
    window.open(url);
  }
  /*
  fnDelete(id) {
    const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
      width: '300px',
      height: '150px',
      data: { headerText: 'Do you want to delete this record?' }
    });
    dialogRef2.afterClosed().subscribe(dialogResult => {
      if (dialogResult == true) {
        this._ccdaService.DeleteClinicalDataExport(id).subscribe((result: string) => {
          if (result.indexOf('success') > -1) {
            this.PatientClinicalDataExportList = this.PatientClinicalDataExportList.filter(i => i.ID != id);
            this._toastrService.success("Successfully Deleted");
          }
          else {
            this._toastrService.error(result);
          }
        });
      }

    })

  }
  */
}
